export default function Answer(questionVal, shortNameVal, answerVal) { 
    this.question = questionVal;
    this.shortName = shortNameVal;
    this.answer = answerVal
}